import React, { useState } from 'react';

// لاحظ أننا نستقبل (orders) كهدية من App.js
const Tracking = ({ orders }) => {
  const [searchId, setSearchId] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSearch = () => {
    // نبحث في القائمة المحدثة
    const foundOrder = orders.find(order => order.id === searchId);

    if (foundOrder) {
      setResult(foundOrder);
      setError('');
    } else {
      setResult(null);
      setError('عذراً، رقم الطلب غير موجود.');
    }
  };

  const getStatusColor = (status) => {
    if (status === "جاهز للاستلام") return "green";
    if (status === "جاري العمل") return "orange";
    return "red";
  };

  return (
    <div style={{ textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
      <h2>🔍 تتبع حالة جهازك</h2>
      
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px' }}>
        <input 
          type="text" 
          placeholder="أدخل رقم الطلب..." 
          value={searchId}
          onChange={(e) => setSearchId(e.target.value)}
          style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        <button onClick={handleSearch} className="btn" style={{ background: '#28a745', color: 'white' }}>بحث</button>
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {result && (
        <div style={{ border: '2px solid #ddd', padding: '20px', borderRadius: '10px', background: '#f9f9f9' }}>
          <h3>الطلب #{result.id}</h3>
          <p><strong>العميل:</strong> {result.clientName}</p>
          <p><strong>الجهاز:</strong> {result.device}</p>
          <div style={{ background: getStatusColor(result.status), color: 'white', padding: '5px', borderRadius: '5px' }}>
            {result.status}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tracking;